export default "__VITE_PUBLIC_ASSET__5ad7256d__"